import AspectWrapper from "core-web/components/AspectWrapper";
import TextShadow from "./TextShadow";
import styled from "theme/libs/styled";

const Wrapper = styled("div")`
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    border-radius: 8px;
`;

const StyledAspectWrapper = styled(AspectWrapper)`
    &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        background: ${({ theme }) => theme.colors.skeletonGradient};
        animation: shimmer ${({ theme }) => theme.transitions.skeletonLoading} infinite;
        content: "";
        z-index: 0;
    }

    @keyframes shimmer {
        100% {
            transform: translateX(100%);
        }
    }
`;

const ImageBox = styled("div")`
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.shadowGrey};
`;

const TextWrapper = styled("div")`
    display: flex;
    flex-direction: column;
    padding: 8px 0;
`;

const ProductCard = () => (
    <Wrapper>
        <StyledAspectWrapper ratio={3 / 4}>
            <ImageBox />
        </StyledAspectWrapper>

        <TextWrapper>
            <TextShadow
                height={["14px", null, null, null, "17px"]}
                width="116px"
                mb={["6px", null, null, null, "8px"]}
            />
            <TextShadow
                height={["14px", null, null, null, "17px"]}
                width="140px"
                mb={["6px", null, null, null, "8px"]}
            />
            <TextShadow height={["14px", null, null, null, "17px"]} width="72px" />
        </TextWrapper>
    </Wrapper>
);

export default ProductCard;
